import React from "react";
import PropTypes from "prop-types";
import TypewriterAnimation from "@default/general-components/typewriter-animation";

export const SocialMedia = ({ content }) => {
  return (
    <div className="col-12 social-media">
      <nav>
        <ul className="row">
          {content.fieldFacebook && (
            <li className="col-12 col-lg-6">
              <a
                className="facebook action-element"
                target="_blank"
                rel="noopener noreferrer"
                href={content.fieldFacebook.uri.path}
              >
                <TypewriterAnimation>Facebook</TypewriterAnimation>
              </a>
            </li>
          )}
          {content.fieldYoutube && (
            <li className="col-12 col-lg-6">
              <a
                className="youtube action-element"
                target="_blank"
                rel="noopener noreferrer"
                href={content.fieldYoutube.uri.path}
              >
                <TypewriterAnimation>YouTube</TypewriterAnimation>
              </a>
            </li>
          )}
          {content.fieldFlickr && (
            <li className="col-12 col-lg-6">
              <a
                className="flickr action-element"
                target="_blank"
                rel="noopener noreferrer"
                href={content.fieldFlickr.uri.path}
              >
                <TypewriterAnimation>Flickr</TypewriterAnimation>
              </a>
            </li>
          )}
          {content.fieldInstagram && (
            <li className="col-12 col-lg-6">
              <a
                className="instagram action-element"
                target="_blank"
                rel="noopener noreferrer"
                href={content.fieldInstagram.uri.path}
              >
                <TypewriterAnimation>Instagram</TypewriterAnimation>
              </a>
            </li>
          )}
          {content.fieldVimeo && (
            <li className="col-12 col-lg-6">
              <a
                className="vimeo action-element"
                target="_blank"
                rel="noopener noreferrer"
                href={content.fieldVimeo.uri.path}
              >
                Vimeo
              </a>
            </li>
          )}
          {content.fieldLinkedin && (
            <li className="col-12 col-lg-6">
              <a
                className="linkedin action-element"
                target="_blank"
                rel="noopener noreferrer"
                href={content.fieldLinkedin.uri.path}
              >
                <TypewriterAnimation>LinkedIn</TypewriterAnimation>
              </a>
            </li>
          )}
          {content.fieldPinterest && (
            <li className="col-12 col-lg-6">
              <a
                className="pinterest action-element"
                target="_blank"
                rel="noopener noreferrer"
                href={content.fieldPinterest.uri.path}
              >
                <TypewriterAnimation>Pinterest</TypewriterAnimation>
              </a>
            </li>
          )}
          {content.fieldX && (
            <li className="col-12 col-lg-6">
              <a
                className="x action-element"
                target="_blank"
                rel="noopener noreferrer"
                href={content.fieldX.uri.path}
              >
                <TypewriterAnimation>X</TypewriterAnimation>
              </a>
            </li>
          )}
          {content.fieldXing && (
            <li className="col-12 col-lg-6">
              <a
                className="xing action-element"
                target="_blank"
                rel="noopener noreferrer"
                href={content.fieldXing.uri.path}
              >
                <TypewriterAnimation>Xing</TypewriterAnimation>
              </a>
            </li>
          )}
          {content.fieldTumblr && (
            <li className="col-12 col-lg-6">
              <a
                className="tumblr action-element"
                target="_blank"
                rel="noopener noreferrer"
                href={content.fieldTumblr.uri.path}
              >
                <TypewriterAnimation>Tumblr</TypewriterAnimation>
              </a>
            </li>
          )}
          {content.fieldSpotify && (
            <li className="col-12 col-lg-6">
              <a
                className="spotify action-element"
                target="_blank"
                rel="noopener noreferrer"
                href={content.fieldSpotify.uri.path}
              >
                <TypewriterAnimation>Spotify</TypewriterAnimation>
              </a>
            </li>
          )}
          {content.fieldTiktok && (
            <li className="col-12 col-lg-6">
              <a
                className="tiktok action-element"
                target="_blank"
                rel="noopener noreferrer"
                href={content.fieldTiktok.uri.path}
              >
                <TypewriterAnimation>TikTok</TypewriterAnimation>
              </a>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};

SocialMedia.propTypes = {
  content: PropTypes.shape({
    fieldFacebook: PropTypes.shape({
      uri: PropTypes.shape({
        path: PropTypes.string,
      }),
    }),
    fieldYoutube: PropTypes.shape({
      uri: PropTypes.shape({
        path: PropTypes.string,
      }),
    }),
    fieldFlickr: PropTypes.shape({
      uri: PropTypes.shape({
        path: PropTypes.string,
      }),
    }),
    fieldInstagram: PropTypes.shape({
      uri: PropTypes.shape({
        path: PropTypes.string,
      }),
    }),
    fieldVimeo: PropTypes.shape({
      uri: PropTypes.shape({
        path: PropTypes.string,
      }),
    }),
    fieldLinkedin: PropTypes.shape({
      uri: PropTypes.shape({
        path: PropTypes.string,
      }),
    }),
    fieldPinterest: PropTypes.shape({
      uri: PropTypes.shape({
        path: PropTypes.string,
      }),
    }),
    fieldX: PropTypes.shape({
      uri: PropTypes.shape({
        path: PropTypes.string,
      }),
    }),
    fieldXing: PropTypes.shape({
      uri: PropTypes.shape({
        path: PropTypes.string,
      }),
    }),
    fieldTumblr: PropTypes.shape({
      uri: PropTypes.shape({
        path: PropTypes.string,
      }),
    }),
  }),
};
